import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPictureInPicture: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPictureInPicture"><Path d="M2 4V18H10V16H4V6H18V12H20V4H2Z" fill="currentColor"/><Path d="M12 14V21H22V14H12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPictureInPicture;
